import { batch } from "react-redux";
import { actions } from 'react-redux-form';
import moment from 'moment';
import {
    orderDetailsFormModel,
    getOrderDetails,
    getAssignedTEMAnalystDropdown,
    getOrderStatusDropdown,
    getApprovalStatusDropdown,
    getLocationCountryDropdown,
    getLocationDeliveryAddressDropdown,
    getUserContactEmailDropdown,
    getTechnicalUserContactEmail,
    getNewQuotationDetails,
    getVendorList,
    setCancelOrderStatus,
    checkCircuitDuplicate,
    setTEMAnalystLoading,
    setCountryLoading,
    setDeliveryAddressLoading,
    setUserContactEmailLoading
} from "../../../constants/model-reducers/external/order/order-details.settings";
import { httpPost, httpGet } from "../../../utils/api.utils";
import { convertToLocalDateToUTCDate, trueFalseToBoolean, convertDateStringToDateFormat } from "../../../utils/helpers.utils";
import { TRANSLATIONS, STRING_VALUES } from '../../../utils/constant.utils';
import { ORDER_STATUS as OrderStatus } from "../../../constants/external-constants";

export const orderDetailsInitialFormState = orderDetailsFormModel;

const defaultState = () => ({
    fetchingOrderDetails: true,
    assignedTEMAnalystDropdown: [],
    orderStatusDropdown: [],
    approvalStatusDropdown: [],
    locationCountryDropdown: [],
    locationDeliveryAddressDropdown: [],
    userContactEmailDropdown: [],
    technicalUserContactEmailDropdown: [],
    orderData: [],
    isCircuitDuplicate: false,
    analystPage: 1,
    hasMoreTEMAnalyst: true,
    isTEMAnalystLoading: false,
    countryPage: 1,
    hasMoreCountry: true,
    isCountryLoading: false,
    deliveryAddressPage: 1,
    hasMoreDeliveryAddress: true,
    isDeliveryAddressLoading: false,

    userContactEmailPage: 1,
    hasMoreUserContactEmail: true,
    technicalUserContactEmailPage: 1,
    isUserEmailLoading: false
});

const initialState = defaultState();

export const orderDetailsActions = {
    getOrderDetails: (orderId) => async (dispatch, state) => {
        dispatch({
            type: getOrderDetails,
            data: {
                fetching: true
            }
        });
        var userId = parseInt(sessionStorage.getItem('UserID'), 10);
        var result = await httpGet(`external/order/getOrderDetails/${orderId}`);
        var data = result.data;
        var orderStatuses = await getOrderStatus();
        var approvalStatuses = await getApprovalStatus();
        await dispatch(orderDetailsActions.getAssignedTEMAnalystDropdownAsync(1, data.AssignedTo));
        await dispatch(orderDetailsActions.getCountriesDropdownAsync(1, data.Country));
        var locationCountries = state().orderDetails.locationCountryDropdown;
        if (data.CountryCode) {
            var dataCountry = locationCountries.find(r => r.Key === data.CountryCode);
            await dispatch(orderDetailsActions.getDeliveryAddressDropdownAsync(dataCountry?.Value, 1, data.DeliveryAddress));
        }

       
        if (data) {
            batch(() => {
                dispatch({
                    type: getOrderStatusDropdown,
                    data: orderStatuses
                });
                dispatch({
                    type: getApprovalStatusDropdown,
                    data: approvalStatuses
                });
                
                //Order Details
                dispatch(actions.load('orderDetailsForm.orderId', data.OrderId));
                dispatch(actions.load('orderDetailsForm.orderNumber', data.OrderNumber));
                dispatch(actions.load('orderDetailsForm.requestor', data.Requestor));
                dispatch(actions.load('orderDetailsForm.owner', data.Owner));
                dispatch(actions.load('orderDetailsForm.requestType', data.RequestType));
                dispatch(actions.load('orderDetailsForm.orderStatusId', data.OrderStatusId));
                dispatch(actions.load('orderDetailsForm.orderStatus', data.OrderStatus));
                dispatch(actions.load('orderDetailsForm.companyCode', data.CompanyCode));
                dispatch(actions.load('orderDetailsForm.srNumber', data.ServiceRequestNumber));
                dispatch(actions.load('orderDetailsForm.assignedTEMAnalystId', data.AssignedToId == 0 ? userId : data.AssignedToId));
                dispatch(actions.load('orderDetailsForm.assignedTEMAnalyst', data.AssignedTo));
                dispatch(actions.load('orderDetailsForm.approvalStatusId', data.ApprovalStatusId));
                dispatch(actions.load('orderDetailsForm.approvalStatus', data.ApprovalStatus));
                dispatch(actions.load('orderDetailsForm.contractTerm', data.ContractTerm));
                dispatch(actions.load('orderDetailsForm.createdDate', data.CreatedDateStr));
                dispatch(actions.load('orderDetailsForm.orderCompletionDate', data.OrderCompletionDateStr));
                dispatch(actions.load('orderDetailsForm.expediteRequest', data.ExpediteRequest));
                dispatch(actions.load('orderDetailsForm.AuditUserId', data.AuditUserId));
                //Approver Details
                dispatch(actions.load('orderDetailsForm.wirelineApproverName', data.WirelineApproverName));
                dispatch(actions.load('orderDetailsForm.wirelineApproverEmail', data.WirelineApproverEmail));
                dispatch(actions.load('orderDetailsForm.wirelineApprovedDate', data.WirelineApproverDateStr));
                dispatch(actions.load('orderDetailsForm.costCodeApproverName', data.CostCodeApproverName));
                dispatch(actions.load('orderDetailsForm.costCodeApproverEmail', data.CostCodeApproverEmail));
                dispatch(actions.load('orderDetailsForm.costCodeApprovedDate', data.CostCodeApproverDateStr));
                dispatch(actions.load('orderDetailsForm.lineManagerName', data.LineManagerName));
                dispatch(actions.load("orderDetailsForm.lineManagerEmail", data.LineManagerEmail));
                dispatch(actions.load("orderDetailsForm.lineManagerApprovedDate", data.LineManagerDateStr));
                dispatch(actions.load("orderDetailsForm.secondLineManagerName", data.SecondLineManagerName));
                dispatch(actions.load("orderDetailsForm.secondLineManagerEmail", data.SecondLineManagerEmail));
                dispatch(actions.load("orderDetailsForm.secondLineManagerApprovedDate", data.SecondLineManagerDateStr));
                //Location Details
                dispatch(actions.load('orderDetailsForm.needByDate', data.NeedByDate ? convertDateStringToDateFormat(data.NeedByDate) : ''));
                dispatch(actions.load('orderDetailsForm.countryId', data.CountryId));
                dispatch(actions.load('orderDetailsForm.countryCode', data.CountryCode));
                dispatch(actions.load('orderDetailsForm.country', data.Country));
                dispatch(actions.load('orderDetailsForm.fixedLocation', data.FixedLocation));
                dispatch(actions.load("orderDetailsForm.deliveryAddressId", data.DeliveryAddressId));
                dispatch(actions.load("orderDetailsForm.deliveryAddress", data.DeliveryAddress));
                dispatch(actions.load("orderDetailsForm.preferredDeliveryAddress", data.PreferredDeliveryAddress));
                //Contact Details
                dispatch(actions.load("orderDetailsForm.localContactEmail", data.LocalContactEmail));
                dispatch(actions.load("orderDetailsForm.localContactFullName", data.LocalContactFullName));
                dispatch(actions.load("orderDetailsForm.localContactPhoneNumber", data.LocalContactNum));
                dispatch(actions.load("orderDetailsForm.altContactId", data.AltContactUserId));
                dispatch(actions.load("orderDetailsForm.altContactEmail", data.AltContactEmail));
                dispatch(actions.load("orderDetailsForm.altContactFullName", data.AltContactFullName));
                dispatch(actions.load("orderDetailsForm.altContactPhoneNumber", data.AltContactNum));
                dispatch(actions.load("orderDetailsForm.techContactId", data.TechContactUserId));
                dispatch(actions.load("orderDetailsForm.techContactEmail", data.TechContactEmail));
                dispatch(actions.load("orderDetailsForm.techContactFullName", data.TechContactFullName));
                dispatch(actions.load("orderDetailsForm.techContactPhoneNumber", data.TechContactNum));

                dispatch({
                    type: getOrderDetails,
                    data: {
                        fetching: false,
                        data: data
                    }
                });
            });

            return data;
        }
    }
    , getUserContactEmail: (pageIndex = 1, searchString = '') => async (dispatch, state) => {

        var userContactEmail = await getUserContactEmail(dispatch, pageIndex, searchString);

        dispatch({
            type: getUserContactEmailDropdown,
            userContactEmail: userContactEmail,
            userContactEmailPage: pageIndex
        });
    }
    , getTechnicalUserContactEmail: (pageIndex = 1, searchString = '') => async (dispatch, state) => {

        var userContactEmail = await getUserContactEmail(dispatch, pageIndex, searchString);

        dispatch({
            type: getTechnicalUserContactEmail,
            technicalUserContactEmail: userContactEmail,
            technicalUserContactEmailPage: pageIndex
        });
    }
    , getAssignedTEMAnalystDropdownAsync: (page = 1, searchString = '') => async (dispatch, state) => {
        const pageSize = 15;

        if (state().orderDetails.isTEMAnalystLoading) return;

        dispatch({
            type: setTEMAnalystLoading,
            payload: true
        });

        let url = `external/order/getAssignedTEMAnalystDropdownAsync/${page}/${pageSize}`;
        if (searchString) {
            url += `?searchString=${encodeURIComponent(searchString)}`;
        }

        try {
            const res = await httpGet(url);

            if (res != null) {
                dispatch({
                    type: getAssignedTEMAnalystDropdown,
                    payload: {
                        analysts: res,
                        analystPage: page
                    }
                });
            }

        } catch (err) {
            console.error("Error fetching TEM Analysts:", err);
        } finally {
            dispatch({
                type: setTEMAnalystLoading,
                payload: false
            });
        }
    },

    getCountriesDropdownAsync: (page = 1, searchString = '') => async (dispatch, state) => {
        const pageSize = 15;

        if (state().orderDetails.isCountryLoading) return;

        dispatch({
            type: setCountryLoading,
            payload: true
        });

        let url = `external/order/getCountriesDropdownListAsync/${page}/${pageSize}`;
        if (searchString) {
            url += `?searchString=${encodeURIComponent(searchString)}`;
        }

        try {
            const res = await httpGet(url);

            if (res != null) {
                dispatch({
                    type: getLocationCountryDropdown,
                    payload: {
                        countries: res,
                        countryPage: page
                    }
                });
            }

        } catch (err) {
            console.error("Error fetching countries:", err);
        } finally {
            dispatch({
                type: setCountryLoading,
                payload: false
            });
        }
    },

    getDeliveryAddressDropdownAsync: (countryName, page = 1, searchString = '') => async (dispatch, state) => {
        const pageSize = 15;

        if (state().orderDetails.isDeliveryAddressLoading) return;

        dispatch({ type: setDeliveryAddressLoading, payload: true });

        let url = `external/order/getDeliveryAddressDropdownAsync/${countryName}/${page}/${pageSize}`;
        if (searchString) url += `?searchString=${encodeURIComponent(searchString)}`;

        try {
            const res = await httpGet(url);

            if (Array.isArray(res)) {
                dispatch({
                    type: getLocationDeliveryAddressDropdown,
                    payload: {
                        deliveryAddresses: res,
                        deliveryAddressPage: page,
                        pageSize
                    }
                });
            }
        } catch (err) {
            console.error("Error fetching delivery addresses:", err);
        } finally {
            dispatch({ type: setDeliveryAddressLoading, payload: false });
        }
    },

    getNewQuotationDetails: (quotationRequestId) => async (dispatch) => {
        dispatch({
            type: getNewQuotationDetails,
            data: {
                fetching: true
            }
        });
        var userId = parseInt(sessionStorage.getItem('UserID'), 10);
        var result = await httpGet(`external/order/getqoutationdetails/${quotationRequestId}`);
        var data = result.data;
        await dispatch(orderDetailsActions.getAssignedTEMAnalystDropdownAsync(1, data.AssignedTo));
        var orderStatuses = await getOrderStatus();
        var approvalStatuses = await getApprovalStatus();

        if (data) {
            batch(() => {
                dispatch({
                    type: getOrderStatusDropdown,
                    data: orderStatuses
                });
                dispatch({
                    type: getApprovalStatusDropdown,
                    data: approvalStatuses
                });

                //Order Details
                dispatch(actions.load('orderDetailsForm.quotationRequestId', data.QuotationRequestId));
                dispatch(actions.load('orderDetailsForm.requestor', data.RequestorEmail));
                dispatch(actions.load('orderDetailsForm.VendorId', data.VendorName));
                dispatch(actions.load('orderDetailsForm.owner', data.EndUserEmail));
                dispatch(actions.load('orderDetailsForm.requestType', data.RequestType));
                dispatch(actions.load('orderDetailsForm.orderStatusId', data.RequestStatusId));
                dispatch(actions.load('orderDetailsForm.orderStatus', data.RequestStatus));
                dispatch(actions.load('orderDetailsForm.companyCode', data.CompanyCode));
                dispatch(actions.load('orderDetailsForm.srNumber', data.RequestNumber));
                dispatch(actions.load('orderDetailsForm.assignedTEMAnalystId', data.AssignedToID == 0 ? userId : data.AssignedToID));
                dispatch(actions.load('orderDetailsForm.assignedTEMAnalyst', data.AssignedTo));
                dispatch(actions.load('orderDetailsForm.approvalStatusId', data.RequestStatusId));
                dispatch(actions.load('orderDetailsForm.approvalStatus', data.ApprovalStatus))
                dispatch(actions.load('orderDetailsForm.createdDate', data.RequestDateStr));
                dispatch(actions.load('orderDetailsForm.orderCompletionDate', data.ApprovedDateStr));

                //Approver Details


                dispatch({
                    type: getNewQuotationDetails,
                    data: {
                        fetching: false,
                        data: data
                    }
                });
            });

            return data;
        }
    },

    getVendorList: (quotationRequestId) => async (dispatch) => {
        dispatch({
            type: getVendorList,
            data: {
                fetching: true
            }
        });
        var result = await httpGet(`external/order/getvendorlist/${quotationRequestId}`);
        var categoryDetailIds = result.map(item => item.VendorName);
        if (categoryDetailIds) {
            batch(() => {
                dispatch(actions.load('orderDetailsForm.vendorList', categoryDetailIds));
                dispatch({
                    type: getVendorList,
                    data: {
                        fetching: false,
                        data: categoryDetailIds
                    }
                });
            });

            return categoryDetailIds;
        }
    },
    setCancelOrderStatus: () => (dispatch) => {
        dispatch(actions.change('orderDetailsForm.orderStatusId', OrderStatus.canceled));
        dispatch({
            type: setCancelOrderStatus,
            data: true
        });
    },
    selectCountry: (model, value) => async (dispatch, state) => {
        const { locationCountryDropdown } = state().orderDetails;

        dispatch(actions.change(model, value));
        dispatch(actions.change('orderDetailsForm.deliveryAddressId', null));
        dispatch(actions.change('orderDetailsForm.preferredDeliveryAddress', null));

        if (value === null) {
            dispatch(actions.change('orderDetailsForm.country', null));
            dispatch({
                type: getLocationDeliveryAddressDropdown,
                payload: {
                    deliveryAddresses: [],
                    deliveryAddressPage: 1,
                    pageSize: 15
                }
            });
        } else {
            const res = locationCountryDropdown.find(r => r.Key === value);
            if (res) {
                dispatch(actions.change('orderDetailsForm.country', res.Value));
                await dispatch(orderDetailsActions.getDeliveryAddressDropdownAsync(res.Value, 1, ''));
            } else {
                dispatch(actions.change('orderDetailsForm.country', null));
            }
        }
    },
    checkCircuitDuplicate: (requestTypeId, orderId) => async (dispatch) => {
        var result = await httpGet(`external/order/checkCircuitValidation/${requestTypeId}/${orderId}`);
        dispatch({
            type: checkCircuitDuplicate,
            data: result
        });
        return result;
    },

    selectTemAnalyst: (model, value) => (dispatch, state) => {
        const { assignedTEMAnalystDropdown } = state().orderDetails;

        dispatch(actions.change(model, value));

        var res = assignedTEMAnalystDropdown.find(r => r.Key == value);


        dispatch(actions.change('orderDetailsForm.assignedTEMAnalystId', ''));
        dispatch(actions.change('orderDetailsForm.assignedTEMAnalyst', res?.Value));

    },

    setDeliveryAddress: (model, value) => (dispatch, state) => {
        dispatch(actions.change(model, value));
        if(value !== -1 && value !== null) {
            dispatch(actions.change('orderDetailsForm.preferredDeliveryAddress', null));
        }
    },
    setContactEmail: (model, value) => (dispatch, state) => {
        const { userContactEmailDropdown, technicalUserContactEmailDropdown } = state().orderDetails;
        dispatch(actions.change(model, value));

        var res = userContactEmailDropdown.find(r => r.UserId == value);
        var techUser = technicalUserContactEmailDropdown.find(r => r.UserId == value)

        if (value !== -1 && value !== null) {
            if (model === 'orderDetailsForm.altContactId') {
                dispatch(actions.change('orderDetailsForm.altContactFullName', res.FullName));
                dispatch(actions.change('orderDetailsForm.altContactPhoneNumber', res.ContactNumber));
            }
            else if (model === 'orderDetailsForm.techContactId') {
                dispatch(actions.change('orderDetailsForm.techContactFullName', techUser.FullName));
                dispatch(actions.change('orderDetailsForm.techContactPhoneNumber', techUser.ContactNumber));
            }
        }
        else {
            if (model === 'orderDetailsForm.altContactId') {
                dispatch(actions.change('orderDetailsForm.altContactFullName', ''));
                dispatch(actions.change('orderDetailsForm.altContactPhoneNumber', ''));
            }
            else if (model === 'orderDetailsForm.techContactId') {
                dispatch(actions.change('orderDetailsForm.techContactFullName', ''));
                dispatch(actions.change('orderDetailsForm.techContactPhoneNumber', ''));
            }
        }
    },

    saveOrderForm: (orderId, requestTypeId) => async (dispatch, state) => {
        try {
            const { form: { forms: { orderDetailsForm: { $form } } } } = state();
            const { orderDetailsForm } = state().form;

            var data = {
                OrderId: parseInt(orderId)
                , AssignedTEMAnalystId: parseInt(orderDetailsForm.assignedTEMAnalystId)
                , OrderStatusId: parseInt(orderDetailsForm.orderStatusId)
                , ApprovalStatusId: parseInt(orderDetailsForm.approvalStatusId)
                , OrderCompletionDate: orderDetailsForm.OrderCompletionDate ? moment(orderDetailsForm.OrderCompletionDate).toISOString(true) : ""
                , ContractTerm: orderDetailsForm.contractTerm
                , ExpediteRequest: orderDetailsForm.expediteRequest
                , NeedByDate: orderDetailsForm.needByDate ? moment(orderDetailsForm.needByDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS') : null
                , FixedLocation: orderDetailsForm.fixedLocation
                , DeliveryAddressId: orderDetailsForm.deliveryAddressId
                , PreferredDeliveryAddress: orderDetailsForm.preferredDeliveryAddress
                , Country: orderDetailsForm.countryCode
                , ServiceRequestNumber: orderDetailsForm.srNumber
                , LocalContactEmail: orderDetailsForm.localContactEmail
                , LocalContactFullName: orderDetailsForm.localContactFullName
                , LocalContactNum: orderDetailsForm.localContactPhoneNumber
                , AltContactUserId: orderDetailsForm.altContactId
                , AltContactNum: orderDetailsForm.altContactPhoneNumber
                , TechContactUserId: orderDetailsForm.techContactId
                , TechContactNum: orderDetailsForm.techContactPhoneNumber
                , RequestTypeId: parseInt(requestTypeId)
            };

            var result = await saveOrder(data);

            if (result.success) {
                dispatch(actions.load("orderDetailsForm", orderDetailsForm));
            }

            return result;
        }
        catch (e) {
            return e;
        }
    },
}

async function getOrderStatus() {
    try {
        var result = await httpGet('external/order/getOrderStatusDropdown');
        return result.data;
    }
    catch (e) {
        return [];
    }
}
async function getApprovalStatus() {
    try {
        var result = await httpGet('external/order/getApprovalStatusDropdown');
        return result.data;
    }
    catch (e) {
        return [];
    }
}
async function getUserContactEmail(dispatch, pageIndex, searchString) {
    const pageSize = 15;

    dispatch({
        type: setUserContactEmailLoading,
        payload: true
    });

    try {
        let url = `external/order/getUserContactEmailDropdown/${pageIndex}/${pageSize}`;

        if (searchString) {
            url += `/${encodeURIComponent(searchString)}`;
        }
        const res = await httpGet(url);

        return res.data;
    }
    catch (e) {
        dispatch({
            type: setUserContactEmailLoading,
            payload: false
        });
        return [];

    } finally {
        dispatch({
            type: setUserContactEmailLoading,
            payload: false
        });
    }
} async function saveOrder(data) {
    try {
        var result = await httpPost(`external/order/details/saveCancel`, data);

        if (result.ok == false) {
            throw {
                success: false,
                message: "Order is not saved. Error encountered while on saving."
            };
        }
        return result;
    }
    catch (e) {
        throw e;
    }
}
export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case getOrderDetails:
            return {
                ...state,
                fetchingOrderDetails: action.data.fetching,
                orderData: action.data.data,
                isOrderCancel: true
            }
        case getAssignedTEMAnalystDropdown:
            const { analysts, analystPage } = action.payload;
            return {
                ...state,
                assignedTEMAnalystDropdown: analystPage === 1
                    ? analysts
                    : [...state.assignedTEMAnalystDropdown, ...analysts],
                hasMoreTEMAnalyst: analysts.length > 0,
                analystPage: analystPage
            };
        case setTEMAnalystLoading:
            return {
                ...state,
                isTEMAnalystLoading: action.payload
            };
        case getLocationCountryDropdown:
            const { countries, countryPage } = action.payload;
            return {
                ...state,
                locationCountryDropdown: countryPage === 1
                    ? countries
                    : [...state.locationCountryDropdown, ...countries],
                hasMoreCountry: countries.length > 0,
                countryPage: countryPage
            };
        case getLocationDeliveryAddressDropdown: {
            const {
                deliveryAddresses = [],
                deliveryAddressPage,
                pageSize = 15,
                totalCount = null
            } = action.payload;

            let mergedList =
                deliveryAddressPage === 1
                    ? deliveryAddresses
                    : [...state.locationDeliveryAddressDropdown, ...deliveryAddresses];
            const seen = new Set();
            const uniqueList = [];
            for (const item of mergedList) {
                if (!seen.has(item.Key)) {
                    seen.add(item.Key);
                    uniqueList.push(item);
                }
            }
            const isLastPage = totalCount !== null
                ? uniqueList.length >= totalCount
                : deliveryAddresses.length < pageSize;

            if (isLastPage) {
                const filtered = uniqueList.filter(i => i.Key !== -1);
                filtered.push({ Key: -1, Value: "Other" });
                return {
                    ...state,
                    locationDeliveryAddressDropdown: filtered,
                    hasMoreDeliveryAddress: false,
                    deliveryAddressPage
                };
            }

            return {
                ...state,
                locationDeliveryAddressDropdown: uniqueList,
                hasMoreDeliveryAddress: deliveryAddresses.length === pageSize,
                deliveryAddressPage
            };
        }

        case setDeliveryAddressLoading:
            return {
                ...state,
                isDeliveryAddressLoading: action.payload
            };
        case setCountryLoading:
            return {
                ...state,
                isCountryLoading: action.payload
            };
        case getNewQuotationDetails:
            return {
                ...state,
                fetchingOrderDetails: action.data.fetching,
                orderData: action.data.data
            };
        case getOrderStatusDropdown:
            return {
                ...state,
                orderStatusDropdown: action.data
            };
        case getApprovalStatusDropdown:
            return {
                ...state,
                approvalStatusDropdown: action.data
            };
        case getUserContactEmailDropdown:
            return {
                ...state,
                userContactEmailDropdown: action.userContactEmailPage === 1 
                    ? action.userContactEmail : [...state.userContactEmailDropdown, ...action.userContactEmail]
                , userContactEmailPage: action.userContactEmailPage
                , hasMoreUserContactEmail: action.userContactEmail.length > 0
            };
        case getTechnicalUserContactEmail:
            return {
                ...state,
                technicalUserContactEmailDropdown: action.technicalUserContactEmailPage === 1
                    ? action.technicalUserContactEmail : [...state.technicalUserContactEmailDropdown, ...action.technicalUserContactEmail]
                , technicalUserContactEmailPage: action.technicalUserContactEmailPage
                , hasMoreUserContactEmail: action.technicalUserContactEmail.length > 0
            };
        case setUserContactEmailLoading:
            return {
                ...state,
                isUserEmailLoading: action.payload
            };
        case getVendorList:
            return {
                ...state,
                fetchingOrderDetails: action.data.fetching,
                vendorList: action.data.data
            };
        case checkCircuitDuplicate:
            return {
                ...state,
                isCircuitDuplicate: action.data
            };
        default:
            return state;
    }
}